import styled, { css } from 'styled-components';
import { ButtonContainer } from '../../button';
import { pxToRem } from '../../../design-tokens/style-utilities';
const bottomSheetFooterContainerStyles = ({ theme }) => css `
	padding: ${pxToRem(theme.spacing['300'])};
	border-top: ${pxToRem(theme.borderWidth['1'])} solid ${theme.colors.light.divider};
	background-color: ${theme.colors.blanc.bgModal};
	position: sticky;
	bottom: 0;

	${ButtonContainer} {
		width: 100%;
	}
`;
export const BottomSheetFooterContainer = styled.footer `
	${bottomSheetFooterContainerStyles}
`;
